<ngx-loading [show]="loading"></ngx-loading>

<h2 mat-dialog-title *ngIf="!thisObject">Adaugare tip nou</h2>
<h2 mat-dialog-title *ngIf="thisObject">Modificare tip: <b>{{thisObject.name}}</b></h2>

<mat-dialog-content style="width: 400px">

  <form [formGroup]="objectForm">

    <div fxLayout fxLayoutWrap fxLayoutGap="25px">
      <mat-form-field style="width: 100%">
        <mat-label>Nume</mat-label>
        <input matInput formControlName="name" style="width: 100%">
        <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
        <mat-error *ngIf="objectForm.get('name').errors?.serverError">{{ objectForm.get('name').errors?.serverError }}</mat-error>
      </mat-form-field>
    </div>
  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="actions">

    <div class="delete-button">
      <button class="mat-raised-button mat-warn" (click)="onDeleteClick()">Delete</button>
    </div>

    <div class="action-buttons">
      <button class="mat-raised-button" mat-dialog-close (click)="onClickCancel()">Inchide</button>
      <button class="mat-raised-button mat-primary" [disabled]="objectForm.invalid"  (click)="onClickSave()" >Salveaza</button>
    </div>

  </div>
</mat-dialog-actions>
